import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'
import { getPrioritySupportContact } from 'selectors/supportContactSelector'
import { errorDetails } from 'constants/flightsCreditRebooking'

import BodyText from 'LuxKit/Typography/BodyText'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import ContactContext, { ContactProvider } from 'contexts/contactContext'

const Root = styled.div`
  border-radius: ${props => props.theme.borderRadius.S};
  padding: ${rem(12)} ${rem(20)};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

const WarningMessage = styled(BodyText)`
  margin-top: ${rem(4)};
`

const CallNowButton = styled(TextButton)`
  margin-top: ${rem(16)};
`

interface Props {
  className?: string;
  currentPriorityNumber: App.GeoContacts;
  error: {
    status: number;
    message: string;
  };
}

function RebookingError(props: Props) {
  const { className, currentPriorityNumber, error } = props
  const description = error.status === 409 ? errorDetails.duplicateBooking : errorDetails.invalidInput
  const contactNumber = useContext(ContactContext)

  return (
    <Root className={className}>
      <BodyText variant="medium" weight="bold">
        {error.message}
      </BodyText>
      <WarningMessage variant="small">
        {description}
      </WarningMessage>
      <ContactProvider contact={currentPriorityNumber}>
        <CallNowButton
          kind="secondary"
          startIcon={<LinePhoneIcon colour="primary" />}
          href={`tel:${contactNumber.local.number}`}
        >
          {contactNumber.local.humanReadable}
        </CallNowButton>
      </ContactProvider>
    </Root>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentPriorityNumber: getPrioritySupportContact(state),
  }
}

export default connect(mapStateToProps)(RebookingError)
